import { render, staticRenderFns } from "./WPRadioGroup.vue?vue&type=template&id=c5f136f2"
import script from "./WPRadioGroup.vue?vue&type=script&lang=ts"
export * from "./WPRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./WPRadioGroup.vue?vue&type=style&index=0&id=c5f136f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports